import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    mode: "history",
    routes: [{
        path: '*',
        redirect: '/'
    }, {
        path: '/giftCard',
        name: 'giftCard',
        component: resolve => require(['@/view/giftCard'], resolve),
        meta: {
            title: '礼品卡'
        }
    }, {
        path: '/',
        name: 'PageView',
        component: resolve => require(['@/view/HomePage'], resolve),
        meta: {
            title: '首页'
        }
        // children: [
        //   {
        //     path: '/',
        //     redirect: '/home'
        //   }, {
        //     path: '/home',
        //     name: 'home',
        //     component: resolve => require(['@/view/HomePage'], resolve),
        //     meta: {
        //       title: '首页'
        //     }
        //   },{
        //     path: '/companyintroduction',
        //     name: 'companyintroduction',
        //     component: resolve => require(['@/view/CompanyIntroduction'], resolve),
        //     meta: {
        //       title: '公司介绍'
        //     }
        //   }
        // ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js